class AccessibleDesign extends HTMLElement {
  constructor() {
    super();
    this.active = this.getState();
    this.rootElement = document.body;
  }

  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.slider = this.querySelector('.toggle-slider');

    if (this.checkbox) {
      this.checkbox.checked = this.active;
      this.updateContent();

      this.checkbox.addEventListener('change', () => this.toggle());
    }
  }

  updateContent() {
    this.rootElement.classList.toggle('accessible-design-mode', this.active);
    document.dispatchEvent(new CustomEvent(`custom:accessible:${this.active.toString()}`));
  }

  toggle() {
    this.active = !this.active;
    this.setState();
    this.updateContent();
  }

  getState() {
    let match = document.cookie.match(/(?:^| )fn_accessible_design_mode=([^;]+)/);
    return match ? !!parseInt(match[1]) : false;
  }

  setState() {
    let d = new Date();
    d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
    document.cookie = `fn_accessible_design_mode=${this.active ? 1 : 0};expires=${d.toUTCString()};path=/`;
  }
}

customElements.define('accessible-design', AccessibleDesign);
